import { useState } from "react";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { CardActions } from "@remo-co/ui-core/src/components/CardActions";
import { CardContent } from "@remo-co/ui-core/src/components/CardContent";
import { FormControl } from "@remo-co/ui-core/src/components/FormControl";
import { Input } from "@remo-co/ui-core/src/components/Input";
import { useI18n } from "i18n";
import { TCAndPrivacyPolicyDisclaimer } from "modules/branding/TCAndPrivacyPolicyDisclaimer";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { selectMagicLinkEmail } from "modules/auth/redux/selectors";
import { useStyles as useCommonStyles } from "../../common/styles";
import { useStyles } from "./styles";

interface Props {
  onSubmit: (email: string) => Promise<void>;
  isSignUp?: boolean;
}

const MagicLinkSignInForm = ({ onSubmit, isSignUp = false }: Props) => {
  const prefilledMagicLinkEmail = useSelector(selectMagicLinkEmail);
  const [email, setEmail] = useState(prefilledMagicLinkEmail ?? "");
  const commonStyles = useCommonStyles();
  const styles = useStyles();
  const { t } = useI18n();

  return (
    <form
      noValidate
      onSubmit={async (event) => {
        event.preventDefault();

        if (!email) {
          return;
        }

        await onSubmit(email);
      }}
      data-testid="magic-link-login-form"
    >
      <CardContent className={commonStyles.cardContent}>
        <FormControl
          className={commonStyles.formControl}
          aria-describedby="email-text"
        >
          <Input
            id="email"
            name="email"
            fullWidth
            autoFocus
            onChange={(event) => {
              setEmail(event.target.value);
            }}
            label={t("auth:email.address")}
            size="sm"
            value={email}
            inputProps={{ "data-testid": "email-input" }}
          />
        </FormControl>
        {isSignUp && <TCAndPrivacyPolicyDisclaimer />}
      </CardContent>
      <CardActions
        className={classNames("card-actions", {
          [styles.tcButtonCard]: isSignUp,
        })}
      >
        <Button
          data-testid="login-button"
          variant="primary"
          color="blue"
          fullWidth
          size="lg"
          type="submit"
          disabled={!email}
        >
          {isSignUp ? t("auth:signup") : t("auth:login")}
        </Button>
      </CardActions>
    </form>
  );
};

export default MagicLinkSignInForm;
